import "@/css/components/weekday-select.scss";
import { Column } from "@enymo/react-layout";
import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { weekdays } from "../common";
import { RadioGroup, WeekdaySelectItem } from "../glidespec";
import { FormInputProps } from "../types";

interface WeekdaySelectProps extends FormInputProps<typeof weekdays[number]> {
    label?: string,
    multiple?: boolean,
    style?: CSSProperties
}

export default function WeekDaySelectSingle({
    label,
    multiple = false,
    style,
    ...props
}: WeekdaySelectProps) {
    const {t} = useTranslation();

    return (
        <Column gap="8px" style={style}>
            {label && <label className="input-label">{label}</label>}
            <RadioGroup className="weekday-select-grid" handlesError {...props}>
                {weekdays.map(weekday => (
                    <WeekdaySelectItem key={weekday} value={weekday}>{t(`weekdays.${weekday}.short`)}</WeekdaySelectItem>
                ))}
            </RadioGroup>
        </Column>
    )
}